import { GET_DRUGS_INTERACTIONS } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

type Exception = { [keys: string]: [string, string][] };

export interface DrugInteractionsResponse {
    interaction: Exception;
}

export interface DrugForInteractions {
    id: string;
    gen_id: string | undefined;
    form: string | undefined;
    product_type: string | undefined;
}

export default (docid: string, drugs: DrugForInteractions[]): Promise<DrugInteractionsResponse> =>
    fetchWithRefresh(GET_DRUGS_INTERACTIONS, {
        method: 'POST',
        body: JSON.stringify({ docid, drugs: drugs }),
        headers: {
            'Content-type': 'application/json',
        },
    }).then((res) => res.json());
